import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=2d468eb9&scoped=true&"
import script from "./Badges.vue?vue&type=script&lang=js&"
export * from "./Badges.vue?vue&type=script&lang=js&"
import style0 from "./Badges.vue?vue&type=style&index=0&id=2d468eb9&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/badges.css?vue&type=style&index=1&id=2d468eb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d468eb9",
  null
  
)

export default component.exports